export enum GradeOperator {
  GREATER_THAN = 1,
  LESS_THAN = 2,
  GREATER_OR_EQUAL = 3,
  LESS_OR_EQUAL = 4
}
